export default __webpack_public_path__ + "static/media/2.d43754e0.jpg";